import { render, staticRenderFns } from "./PermissionIndex.vue?vue&type=template&id=3e8acada&scoped=true&"
import script from "./PermissionIndex.vue?vue&type=script&lang=js&"
export * from "./PermissionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8acada",
  null
  
)

export default component.exports